<template>
  <div class="wrapper" v-if="isShow">
    <div class="block-layer border-bottom">
      <div class="location-layer">
        <div class="location">您在</div>
        <div class="city">{{cityname}}</div>
      </div>
      <img v-if="citysrc" :src="citysrc" @click="goPage2()" />
    </div>

    <div class="block-layer border-bottom">
      <div class="block-title">热门城市</div>
      <div class="block-content">
        <div class="item" v-for="item in hotlist" @click="goPage(item)">{{item.name}}</div>
      </div>
    </div>

    <div class="block-layer border-bottom" v-for="item in areaslist">
      <div class="block-title">{{item.name}}区域</div>
      <div class="block-content">
        <div class="item" v-for="iitem in item.list" @click="goPage(iitem)">{{iitem.name}}</div>
      </div>
    </div>
  </div>
</template>
<script>
import util from "@/utils/utils";
import * as comreq from "@/utils/comreq";
import { MessageBox } from "mint-ui";
import wxsdk from "@/utils/wxsdk";
import Cookies from "js-cookie";
export default {
  components: {},
  data() {
    return {
      isShow: false,
      cityname: "未获取定位",
      citysrc: "",
      cityurl: "",
      jsonData: null,
      hotlist: [],
      areaslist: []
    };
  },
  computed: {},
  watch: {},
  filters: {},
  methods: {
    // lj01
    goPage(item) {
      let that = this;
      if (item.url == "##") {
        MessageBox.alert("敬请期待");
      } else if (item.url == "####") {
      } else {
        let url = `${item.url}&miniproj=${item.minipid}&from=sysintro`;
        Cookies.set("HAS_CITY_URL_HF2", url, { expires: 7 });
        util.openYqRsMakeLink(url);
      }
    },
    // lj01
    goPage2() {
      let that = this;
      if (that.cityurl == "##") {
        MessageBox.alert("敬请期待");
      } else if (that.cityurl == "####") {
      } else if (that.cityurl) {
        let url = `${that.cityurl}&from=sysintro`;
        Cookies.set("HAS_CITY_URL_HF2", url, { expires: 7 });
        util.openYqRsMakeLink(url);
      }
    },
    checkBindGzhInfo() {
      let that = this;
      return new Promise(resolve => {
        // 绑定
        if (
          that.$route.query.xcxuid &&
          that.$route.query.xcxappid &&
          that.$route.query.xcxprojectid
        ) {
          comreq
            .bindRsGzhinfo({
              uid: that.$route.query.xcxuid,
              appid: that.$route.query.xcxappid,
              projectid: that.$route.query.xcxprojectid,
              gzhAppid: that.global.APPID,
              gzhOpenid: that.$openid,
              gzhPassport: that.$passport
            })
            .then(data => {
              console.log("bindRsGzhinfo", data);
              resolve();
            });
        } else {
          resolve();
        }
      });
    },
    init() {
      let that = this;
      //有缓存则自动跳转
      if (Cookies.get("HAS_CITY_URL_HF2") && that.$route.query.from != "t9") {
        window.location.href = Cookies.get("HAS_CITY_URL_HF2");
      }

      //没有缓存
      comreq.getAreaByIp().then(data => {
        if (data.code == 1) {
          if (data.data && data.data.city) {
            that.cityname = data.data.city;
            // that.cityname = '上海'
            that.areaslist.forEach(item => {
              item.list.forEach(e => {
                if (e.name == that.cityname) {
                  //获取定位
                  that.cityname = "";
                  that.cityurl = e.url + "&miniproj=" + e.minipid;
                  that.citysrc = e.src;
                  if (that.$route.query.from == "t9") {
                    that.isShow = true;
                  } else if (e.url != "##" || e.url != "####") {
                    Cookies.set("HAS_CITY_URL_HF2", e.url, { expires: 7 });
                    window.location.href = `${e.url}`;
                  }
                }
              });
            });
            setTimeout(() => {
              that.isShow = true;
            }, 300);
          } else {
            that.isShow = true;
          }
        } else {
          that.isShow = true;
        }
      });

      //设置分享
      that.global.SHARE_TITLE = `华发股份线上售楼中心，看房咨询一步到位，最新购房优惠抢先看！`;
      that.global.SHARE_DESC = `美好人居，一触即达。帮忙传播，更有多重惊喜哟！`;
      that.global.SHARE_IMG_URL =
        "https://assets.rurushishi.com//yq-rs-make/sysintro/share.jpg";
      let shareLink = `${location.protocol}//${location.host}/h5/huafa/sysintro`;
      that.global.SHARE_LINK = shareLink;
      wxsdk.init();
    }
  },
  mounted() {
    let that = this;
    comreq.getSalerBuildingConfig().then(data => {
      that.jsonData = JSON.parse(data.obj);
      that.hotlist = that.jsonData.hots;
      that.areaslist = that.jsonData.areas;
      that.checkBindGzhInfo().then(() => {
        that.init();
      });
    });
  }
};
</script>
<style lang="stylus" scoped>
.header-layer {
  line-height: 0.8rem;
  font-size: 0.32rem;
  color: #333333;
  font-weight: bold;
  background: url('https://assets.rurushishi.com//yq-rs-make/sysintro/icon_logo.png') no-repeat left center;
  background-size: 0.45rem 0.4rem;
  padding-left: 0.6rem;
  margin-left: 0.3rem;
}

.menu-layer {
  padding: 0 0.3rem;
  display: flex;
  flex-wrap: wrap;
}

.menu-layer .menu-item {
  width: 1.55rem;
  height: 0.7rem;
  border-radius: 0.6rem;
  background-color: #F6F7F9;
  font-size: 0.28rem;
  color: #666666;
  font-weight: bold;
  margin-top: 0.2rem;
  line-height: 0.7rem;
  text-align: center;
  margin-right: 0.15rem;
}

.menu-layer .menu-item.active {
  color: #ffffff;
  background: linear-gradient(to right, #D23F15, #FF8E8E);
}

.city-layer {
  padding: 0.2rem 0.3rem;
}

.city-layer .city-item {
  width: 100%;
  // height: 2rem
  margin-top: 0.2rem;
}

.city-layer .city-item > img {
  display: block;
  width: 100%;
}

// .wrapper {
// position: absolute;
// left: 0;
// top: 0;
// bottom: 0;
// right: 0;
// overflow: hidden;
// background-color: #efefef;
// }

// .header-layer > img{
// width: 100%;
// height: 2.18rem;
// display: block;
// }

// .pannel-layer {
// position: absolute;
// left: 0;
// top: 2.18rem;
// bottom: 0;
// right: 0;
// overflow: hidden;
// display: flex;
// }

// .pannel-layer .menu-layer {
// width: 1.5rem
// overflow-y: auto;
// -webkit-overflow-scrolling: touch;
// }

// .pannel-layer .menu-layer .menu-item {
// line-height: .8rem
// text-align: center
// font-size: .26rem
// color: #212121
// position: relative
// }

// .pannel-layer .menu-layer .menu-item.active {
// color: #1995F4
// background-color: #fff
// }

// .pannel-layer .menu-layer .menu-item.active::after {
// position: absolute
// content: ''
// top: 0
// left: 0
// bottom: 0
// width: 8px
// background-color: #1995F4
// }

// .pannel-layer .house-layer {
// flex: 1
// background-color: #fff
// overflow-y: auto;
// -webkit-overflow-scrolling: touch;
// padding: 0 0.2rem
// // margin-bottom: .88rem
// // display: flex;
// // flex-wrap: wrap;
// }

// .pannel-layer .house-layer .house-item {
// height: 2.5rem
// text-align: center
// width: 2.5rem
// line-height: .6rem
// margin: .15rem
// background-color: #efefef
// display: inline-block
// }

// .pannel-layer .house-layer .house-item > img {
// width: 100%;
// display: block;
// }
.block-layer {
  width: 92%;
  margin: 0 auto;
  padding: 0.2rem 0;
}

.block-layer .block-title {
  line-height: 0.6rem;
  font-weight: bold;
  color: #333333;
  font-size: 0.32rem;
}

.block-layer .block-content {
  display: flex;
  flex-wrap: wrap;
}

.block-layer .block-content .item {
  width: 22%;
  height: 0.7rem;
  border: 1px solid #B6B6B6;
  text-align: center;
  line-height: 0.7rem;
  border-radius: 4px;
  margin-right: 0.15rem;
  margin-top: 0.2rem;
  color: #333333;
  font-size: 0.28rem;
}

.block-layer .location-layer {
  display: flex;
  line-height: 0.8rem;
}

.block-layer .location-layer .location {
  color: #333333;
  font-size: 0.32rem;
  font-weight: bold;
  background: url('https://assets.rurushishi.com//yq-rs-make/sysintro/icon_location.png') no-repeat right center;
  background-size: 0.34rem 0.34rem;
  padding-right: 0.5rem;
}

.block-layer > img {
  display: block;
  width: 100%;
}
</style>